import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import SuccessPage from "./pages/SuccessPage";
import CancelPage from "./pages/CancelPage";
import Diagnostico from "./pages/Diagnostico";
import { Toaster } from "sonner";

function App() {
  return (
    <div className="App grain">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/workbook" element={<LandingPage />} />
          <Route path="/livro" element={<LandingPage />} />
          <Route path="/w" element={<LandingPage />} />
          <Route path="/sucesso" element={<SuccessPage />} />
          <Route path="/cancelado" element={<CancelPage />} />
          <Route path="/diagnostico" element={<Diagnostico />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-center" />
    </div>
  );
}

export default App;
